import { useResourceThread } from '../../hooks/useResource';
import { useResourceViewerStore } from '../../stores/resourceViewerStore';
import { ResourceRow } from '../ResourceRow';
import type { Resource } from '../../types/resource';

interface Props {
  projectId: string;
  collectionId: string;
  resourceId: string;
}

export default function ConversationTab({ projectId, collectionId, resourceId }: Props) {
  const { data: threads, isLoading } = useResourceThread(projectId, collectionId, resourceId);
  const open = useResourceViewerStore((s) => s.open);

  function openResource(r: Resource) {
    open({ projectId: r.projectId, collectionId: r.collectionId, resourceId: r.id });
  }

  const content = isLoading ? (
    <div className="alert alert-info">Loading conversation…</div>
  ) : !threads?.length ? (
    <div className="alert alert-info alert-block">
      <h4>No conversations found</h4>
      <p>This document does not belong to a conversation</p>
    </div>
  ) : (
    // The scroll container has to be the wrapper, not `.iio-resource-medias` itself:
    // as a flex item it would take a definite height, and ResourceRow's `height: 100%`
    // (needed inside ag-grid cells) would stretch every row to fill the pane.
    <div style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
      <div className="iio-resource-medias" data-testid="viewer-thread-list">
        {threads.map((r) => (
          <ResourceRow key={r.id} resource={r} onClick={openResource} hideThumbnail noIndent />
        ))}
      </div>
    </div>
  );

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', padding: 10, boxSizing: 'border-box', overflow: 'hidden' }}>
      <h4 style={{ flexShrink: 0, marginTop: 0 }}>Conversation</h4>
      {content}
    </div>
  );
}
